import ModalPortal from '@/components/ModalPortal';
import { motion, AnimatePresence } from 'framer-motion';

interface CoreDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm?: () => void;
    title: string;
    description: string | React.ReactNode;
    type?: 'danger' | 'info' | 'success';
    confirmLabel?: string;
}

const CoreDialog = ({
                        isOpen,
                        onClose,
                        onConfirm,
                        title,
                        description,
                        type = 'info',
                        confirmLabel = 'Confirmar'
                    }: CoreDialogProps) => {

    // Cores dinâmicas baseadas no tipo
    const themes = {
        danger: { text: 'text-red-500', bg: 'bg-red-500/10', border: 'border-red-500/20', button: 'bg-red-600 hover:bg-red-500 shadow-red-900/20' },
        info: { text: 'text-cyan-500', bg: 'bg-cyan-500/10', border: 'border-cyan-500/20', button: 'bg-cyan-600 hover:bg-cyan-500 shadow-cyan-900/20' },
        success: { text: 'text-emerald-500', bg: 'bg-emerald-500/10', border: 'border-emerald-500/20', button: 'bg-emerald-600 hover:bg-emerald-500 shadow-emerald-900/20' }
    };

    const theme = themes[type];

    return (
        <AnimatePresence>
            {isOpen && (
                <ModalPortal><motion.div
                    initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                    className="fixed inset-0 z-[1000] bg-black/80 backdrop-blur-md flex items-center justify-center p-4"
                >
                    <motion.div
                        initial={{ scale: 0.95, opacity: 0, y: 20 }}
                        animate={{ scale: 1, opacity: 1, y: 0 }}
                        exit={{ scale: 0.95, opacity: 0, y: 20 }}
                        className={`bg-[#161e2d] border ${theme.border} w-full max-w-sm rounded-[2.5rem] p-8 shadow-2xl text-center relative overflow-hidden`}
                    >
                        {/* Detalhe estético: Brilho de fundo */}
                        <div className={`absolute -top-24 -left-24 w-48 h-48 ${theme.bg} blur-[80px] rounded-full`} />

                        <h3 className={`text-white font-black uppercase italic tracking-tighter text-lg mb-2 relative`}>
                            {title}
                        </h3>

                        <div className="text-slate-400 text-[11px] mb-8 uppercase font-bold tracking-wider leading-relaxed relative">
                            {description}
                        </div>

                        <div className="flex gap-3 relative">
                            <button
                                onClick={onClose}
                                className="flex-1 bg-white/5 hover:bg-white/10 text-white font-black py-4 rounded-2xl text-[10px] transition-all uppercase tracking-widest border border-white/5"
                            >
                                Cancelar
                            </button>
                            {onConfirm && (
                                <button
                                    onClick={onConfirm}
                                    className={`flex-1 ${theme.button} text-white font-black py-4 rounded-2xl text-[10px] transition-all shadow-xl uppercase tracking-[0.2em]`}
                                >
                                    {confirmLabel}
                                </button>
                            )}
                        </div>
                    </motion.div>
                </motion.div></ModalPortal>
            )}
        </AnimatePresence>
    );
};

export default CoreDialog;
